import NotSupported from './NotSupported';
import tags, { bubbleTags } from './tags';

export * from './Native/index';
export * from './NotNative/index';
export { bubbleTags, NotSupported };
export default tags;
